import { apiRequest } from "./common";

const getAllTickets = async (pageNo, pageSize, status) => {
    const response = await apiRequest('get', `/support-ticket?page=${pageNo}&limit=${pageSize}&status=${status}`);
    return response.data;
};

const createTicket = async (data) => {
    const response = await apiRequest('post', `/support-ticket`, data);
    return response.data;
};

const sendMessageToTicket = async (ticketId, data) => {
    const response = await apiRequest('post', `/support-ticket/${ticketId}/messages`, data);
    return response.data;
};

const getTicketDetails = async (ticketId) => {
    const response = await apiRequest('get', `/support-ticket/${ticketId}`);
    return response.data;
};

const updateTicket = async (id, data) => {
    const response = await apiRequest('put', `/support-ticket/${id}`, data);
    return response.data;
};

export {
    getAllTickets,
    createTicket,
    sendMessageToTicket,
    getTicketDetails,
    updateTicket
}